import { Button } from '@bosch/react-frok'
import ProfileBadge from '../../ProfileBadge/ProfileBadge'

import './CustomActions.scss'
import { CustomActionsProps } from './types/CustomActionsTypes'

const CustomActions = ({ showDetails }: CustomActionsProps) => {

    return (
        <div className="custom-actions">
            <Button
                icon="info-i"
                mode="integrated"
                onClick={(event: React.MouseEvent<HTMLElement>) =>
                    showDetails(event, 'documentation', 'bottom')
                }
            />

            <ProfileBadge onClick={(event) => showDetails(event, 'user', 'bottom')} />
        </div>
    )
}

export default CustomActions
